import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../i18n";

/**
 * Switch FR / EN — minimaliste, aligné avec la nav éditoriale Pulaar.
 * Langue active : opacité forte + soulignée discrètement.
 * Langue inactive : opacité 50%, hover 100%.
 */
export default function LanguageSwitch({ className = "", testId = "lang-switch" }) {
  const { i18n } = useTranslation();
  const [current, setCurrent] = useState(
    () => (i18n.language?.startsWith("en") ? "en" : "fr"),
  );

  useEffect(() => {
    const handler = (lng) => {
      setCurrent(lng?.startsWith("en") ? "en" : "fr");
    };
    i18n.on("languageChanged", handler);
    return () => {
      i18n.off("languageChanged", handler);
    };
  }, [i18n]);

  const Btn = ({ code, label }) => (
    <button
      type="button"
      onClick={() => setLanguage(code)}
      data-testid={`${testId}-${code}`}
      aria-label={`Switch to ${label}`}
      aria-pressed={current === code}
      className={`text-[11px] tracking-[0.28em] uppercase transition-opacity duration-300 ${
        current === code
          ? "text-[#121212] underline underline-offset-[6px] decoration-[0.5px] opacity-100"
          : "text-[#121212] opacity-50 hover:opacity-100"
      }`}
    >
      {label}
    </button>
  );

  return (
    <div
      data-testid={testId}
      className={`inline-flex items-center gap-2 ${className}`}
    >
      <Btn code="fr" label="FR" />
      <span className="text-[11px] text-[#121212]/40">/</span>
      <Btn code="en" label="EN" />
    </div>
  );
}
